/**
 * Created by Pierrot on 08/10/2014.
 */
'use strict';
import * as _ from 'lodash';

module.exports = function (angular) {

    return { 
        engine: function(data){
            console.log(data);

            let progression = 0;
            let timePool = data.setting.totalTime;

            let path = data.path;
            let cities = _.chain(data.cities).clone().each((o,key)=>{
                o.id = key;
                return o;
            }).value();
            let lastCity = null;
            let currentCity = null;

            function _getPathCity(index){
                return cities[path[index].city];
            }

            function _decrTime(value){
                timePool -= value;
                if(timePool <= 0){
                    return true;
                }
                return false;
            }

            return{
                init(){
                    progression = 0;
                    currentCity = _getPathCity(progression);
                    timePool = data.setting.totalTime;
                },
                getCurrentNode(){
                    console.log("progression "+progression,path.length);
                    const city = _.cloneDeep(currentCity);
                    console.log(city);
                    const node = path[progression];
                    if(currentCity.id == node.city && node.clues){
                        _.each(city.places,(place,key)=>{
                            place.clue = node.clues[key];
                        });
                    }

                    if(progression >= path.length -1){
                        return {
                            city:city,
                            gameover:true,
                            success:timePool > 0,
                            timePool:timePool
                        }
                    }

                    const choices = _.chain(path[progression].links || [])
                        .concat(lastCity?[lastCity.id]:[])
                        .concat(city.links || [])
                        .uniq()
                        .filter((o)=>o!==city.id)
                        .shuffle()
                        .map((city)=>{
                            return {
                                id:city,
                                name:cities[city]?cities[city].name:city+' non défini'
                            }
                    }).value();

                    return {
                        city:city,
                        choices:choices,
                        timePool:timePool
                    };
                },
                travelTo(id){
                   
                    if( progression + 1 < path.length && path[progression+1].city == id){
                        progression++;
                    }
                    lastCity = currentCity;
                    currentCity = cities[id];
                    return {
                        gameover:_decrTime(data.setting.cost.travel)
                    }
                },
                investigate(){
                    const gameover = _decrTime(data.setting.cost.investigate);
                    return {
                        gameover:gameover,
                        timePool:timePool
                    }
                }
            };
        }
    };
};